import { unstable_createMuiStrictModeTheme } from "@material-ui/core/styles";

// A custom theme for this app
const theme = unstable_createMuiStrictModeTheme({
	overrides: {
		MuiMenuItem: {
			root: {
				"&$selected": {
					backgroundColor: "green",
					color: "white",
				},
				"&$selected:hover": {
					backgroundColor: "gray",
				},
			},
		},
		MuiTooltip: {
			tooltip: {
				fontSize: "1rem",
				color: "white",
				backgroundColor: "#333",
			},
		},
	},
});

export default theme;
